@if (!editing && !noActivationState) {
  <div class="custom-input" [ngClass]="{ 'no-answer': noAnswer }">
    <a (click)="activate($event)" class="text-block" [ngClass]="{ 'placeholder': activationLabel == placeholder }" [formattedContent]="activationLabel" [isHtmlContent]="inputType == inputTypeEnum.Editor"></a>
    @if (enableNoAnswerChoice && !editing && inputType != inputTypeEnum.Approval) {
      <span
        class="far fa-comment-slash context-btn no-answer"
        [ngStyle]="{ 'display': noAnswer ? 'block' : '' }"
      (click)="setNoAnswer()"></span>
    }
  </div>
}
@if (editing || noActivationState) {
  <div>
    @if (inputType == inputTypeEnum.Select) {
      <custom-select
        [selectList]="selectList"
        [value]="value"
        [placeholder]="placeholder"
        (keydown.escape)="cancel()"
        (blur)="blur()"
        (valueChange)="valueChanged($event)"
      class="editable-field"></custom-select>
    }
    @if (inputType == inputTypeEnum.DateTime) {
      <div class="date-time">
        @if (editing || dirty) {
          <div (click)="cancel()" title="{{ 'general.cancel-changes-tooltip' | translate }}" class="reject"></div>
        }
        <date-time-input [value]="valueAsDateTime"
          (keydown.escape)="cancel()"
          (blur)="blur()"
          (focus)="editing = $event"
          [label]="placeholder"
          [maxDate]="maxDate"
          (valueChange)="dateTimeValueChanged($event)"
          [keepFocus]="dirty"
        class="editable-field"></date-time-input>
        @if (editing || dirty) {
          <div (click)="confirm()" title="{{ 'general.save-changes-tooltip' | translate }}" class="confirm" [ngClass]="{ disabled: editValue == value }"></div>
        }
      </div>
    }
    @if (inputType == inputTypeEnum.Date) {
      <date-input
        [value]="valueAsDate"
        (keydown.escape)="cancel()"
        (blur)="blur()"
        [label]="placeholder"
        (valueChange)="valueChanged($event)"
      class="editable-field"></date-input>
    }
    @if (inputType != inputTypeEnum.Date && inputType != inputTypeEnum.Select && inputType != inputTypeEnum.DateTime) {
      <div>
        @if (editing) {
          <div (click)="cancel()" title="{{ 'general.cancel-changes-tooltip' | translate }}" class="reject"></div>
        }
        <custom-input [inputType]="inputType"
          (keydown.escape)="cancel()"
          (blur)="blur()"
          (keyup.enter)="(inputType != inputTypeEnum.Textarea && inputType != inputTypeEnum.Editor && inputType != inputTypeEnum.Approval) ? confirm() : null;"
          [value]="editing ? editValue : value"
          (valueChange)="valueChanged($event)"
          [placeholder]="placeholder"
          class="editable-field"
          [noAnswer]="noAnswer"
          [allowMultiLine]="allowMultiLine"
          [ignoreFormValidation]="true">
        </custom-input>
        @if (editing) {
          <div (click)="confirm()" title="{{ 'general.save-changes-tooltip' | translate }}" class="confirm" [ngClass]="{ disabled: editValue == value }"></div>
        }
      </div>
    }
  </div>
}
